// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XLwBC","col":"styles_col__290SL"};